import { render } from "./ShippingItemsTab.vue?vue&type=template&id=28bc23c2&scoped=true"
import script from "./ShippingItemsTab.vue?vue&type=script&lang=js"
export * from "./ShippingItemsTab.vue?vue&type=script&lang=js"

import "./ShippingItemsTab.vue?vue&type=style&index=0&id=28bc23c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bc23c2"]])

export default __exports__